import { render, staticRenderFns } from "./model_tag_category.vue?vue&type=template&id=5a3a6167&scoped=true"
import script from "./model_tag_category.vue?vue&type=script&lang=ts"
export * from "./model_tag_category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a6167",
  null
  
)

export default component.exports